<router-outlet></router-outlet>
<router-outlet name="modal"></router-outlet>
<app-data-model *ngIf="true" ngSkipHydration></app-data-model>
<app-loader></app-loader>
<app-consent></app-consent>
